// extracted by mini-css-extract-plugin
module.exports = {"container":"e_8A","styleWarning":"e_9A"};